import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { BaseServices } from './../../kuba.services';
import { KubaControlService } from './kuba-control.service';
import { BusinessDepartmentService } from './../../business-department.services';
import { FoodSafetyList } from 'src/app/kuba/foodsafety/models';

@Injectable()
export class KubaControlListResolver {
    constructor(private backend: KubaControlService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<FoodSafetyList[]> {
        return this.backend.getAllByBusinessId(BaseServices.BusinessId);
    }
}
    
@Injectable()
export class FoodSafetyListResolver {
    constructor(private backend: KubaControlService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<FoodSafetyList[]> {
        return this.backend.getAllByBusinessId(BaseServices.BusinessId);
    }
}
@Injectable()
export class FoodSafetyEditResolver {
    constructor(private backend: KubaControlService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<FoodSafetyList[]> {
        if (+route.params['id'] > 0) {
            return this.backend.getFoodsafetyById(+route.params['id']);
        } else { return null; }
    }

}
@Injectable()
export class ZoneListResolver {
    constructor(private backend: KubaControlService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<FoodSafetyList[]> {
        return this.backend.getZoneName(BaseServices.BusinessId);
    }

}

@Injectable()
export class ObjectTypeListResolver {
    constructor(private backend: KubaControlService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<FoodSafetyList[]> {
        return this.backend.getTypeOfObject(BaseServices.BusinessId);
    }
}
@Injectable()
export class DepartmentResolver {
    constructor(private backend: BusinessDepartmentService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<FoodSafetyList[]> {
        return this.backend.getCachedBusinessDepartment();
    }

}

@Injectable()
export class FoodsafetyFeaturesResolver {
    constructor(private backend: KubaControlService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<any> {
        return this.backend.getFoodsafetyFeatures(BaseServices.BusinessId);
    }
}

@Injectable()
export class FoodSafetyListByUserResolver {
    constructor(private backend: KubaControlService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<FoodSafetyList[]> {
        return this.backend.getFoodByUser(BaseServices.UserId);
    }
}
@Injectable()
export class FoodSafetyZonesResolver {
    constructor(private backend: KubaControlService) { }
    resolve(): Observable<FoodSafetyList[]> {
        return this.backend.getZonesbyBusiness();
    }
}
@Injectable()
export class FSDailyTaskListResolver {
    constructor(private backend: KubaControlService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<FoodSafetyList[]> {
        return this.backend.getFSDailyTaskList(+route.params['Id']);
    }
}
@Injectable()
export class FSAuditListResolver {
    constructor(private backend: KubaControlService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<FoodSafetyList[]> {
        let MinDate = null;
        let MaxDate = null;
        return this.backend.foodSafetyAuditList(+route.params['Id'], MinDate, MaxDate, false);
    }
}

@Injectable()
export class HazardAnalysisListResolver {
    constructor(private backend: KubaControlService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
        return this.backend.getHazardAnalysis(+route.params['Id']);
    }
}

@Injectable()
export class FSAuditDateListResolver {
    constructor(private backend: KubaControlService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<FoodSafetyList[]> {
        return this.backend.foodSafetyAuditDateList(+route.params['Id']);
    }
}
@Injectable()
export class ToDoListResolver {
    constructor(private backend: KubaControlService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
        return this.backend.getAllApprovedForKubaControlToDoList(+route.params['Id']);
    }
}

@Injectable()
export class ToDoDocumentResolver {
    constructor(private backend: KubaControlService) { }
    resolve(route: ActivatedRouteSnapshot): Observable<any[]> {
        return this.backend.getTodoDocumnet(+route.params['Id'],BaseServices.UserId);
    }
}